<p-toast position="top-right"></p-toast>
@if(showCuiBanner()){
  <div class="cui-banner">
    <p class="ml-auto p-0 px-1 text-center">
      Do not upload <b>CONTROLLED UNCLASSIFIED INFORMATION (CUI)</b> or <b>CLASSIFIED</b> materials
    </p>
    <p-button [dt]="buttonTextPrimaryHoverBackground" severity="primary" (onClick)="acknowledgeCuiBanner()" class="ml-auto pr-2" [style]="{'color': 'white'}" icon="pi pi-times" text></p-button>
  </div>
}
<bs-top-navigation>
</bs-top-navigation>
<bs-side-navigation>
    <div class="layout-grid-body">
        <router-outlet></router-outlet>
    </div>
</bs-side-navigation>


